// extracted by mini-css-extract-plugin
module.exports = {"redirectionComponentContainer":"modalComponent_redirectionComponentContainer__L7RNa","redirectionComponentContent":"modalComponent_redirectionComponentContent__2yxaJ"};